import React from 'react';
import { useCurrency } from '../context/CurrencyContext';
import './ShippingInfo.css';

const ShippingInfo = () => {
  const { currency } = useCurrency();

  // Function to get currency symbol
  const getCurrencySymbol = () => {
    if (currency === '$') return '$';
    else if (currency === '£') return '£';
    else if (currency === 'AED') return 'د.إ';
    else if (currency === 'KSA') return 'ر.س';
    return '£'; // Default fallback
  };

  return (
    <div className="shipping-page">
      {/* Hero Section */}
      <div className="shipping-hero">
        <div className="shipping-hero-content">
          <h1>Shipping Information</h1>
          <p>Fast, reliable shipping to your doorstep</p>
        </div>
      </div>

      <div className="shipping-container">
        <div className="shipping-content">
          <div className="shipping-section">
            <h2>Shipping Options</h2>
            <div className="shipping-options">
              <div className="shipping-option">
                <div className="option-icon">🚚</div>
                <h3>Standard Shipping</h3>
                <p className="delivery-time">3-5 Business Days</p>
                        <p className="price">{getCurrencySymbol()}5.99</p>
        <p className="description">Free on orders over {getCurrencySymbol()}50</p>
              </div>
              <div className="shipping-option">
                <div className="option-icon">⚡</div>
                <h3>Express Shipping</h3>
                <p className="delivery-time">1-2 Business Days</p>
                <p className="price">{getCurrencySymbol()}12.99</p>
                <p className="description">Priority handling and tracking</p>
              </div>
              <div className="shipping-option">
                <div className="option-icon">🌍</div>
                <h3>International</h3>
                <p className="delivery-time">7-14 Business Days</p>
                <p className="price">{getCurrencySymbol()}19.99</p>
                <p className="description">Available to most countries</p>
              </div>
            </div>
          </div>

          <div className="shipping-section">
            <h2>Shipping Process</h2>
            <div className="process-steps">
              <div className="process-step">
                <div className="step-number">1</div>
                <div className="step-content">
                  <h3>Order Placed</h3>
                  <p>Your order is received and confirmed</p>
                </div>
              </div>
              <div className="process-step">
                <div className="step-number">2</div>
                <div className="step-content">
                  <h3>Processing</h3>
                  <p>We prepare and package your items</p>
                </div>
              </div>
              <div className="process-step">
                <div className="step-number">3</div>
                <div className="step-content">
                  <h3>Shipped</h3>
                  <p>Your package is shipped with tracking</p>
                </div>
              </div>
              <div className="process-step">
                <div className="step-number">4</div>
                <div className="step-content">
                  <h3>Delivered</h3>
                  <p>Package arrives at your doorstep</p>
                </div>
              </div>
            </div>
          </div>

          <div className="shipping-section">
            <h2>Tracking Your Order</h2>
            <div className="tracking-info">
              <div className="tracking-card">
                <h3>Order Confirmation</h3>
                <p>You'll receive an email confirmation with your order number and estimated delivery date.</p>
              </div>
              <div className="tracking-card">
                <h3>Shipping Notification</h3>
                <p>When your order ships, you'll get an email with tracking information and a link to track your package.</p>
              </div>
              <div className="tracking-card">
                <h3>Delivery Updates</h3>
                <p>Track your package in real-time and receive delivery notifications via email or SMS.</p>
              </div>
            </div>
          </div>

          <div className="shipping-section">
            <h2>Shipping Restrictions</h2>
            <div className="restrictions-grid">
              <div className="restriction-item">
                <h3>✅ What We Ship</h3>
                <ul>
                  <li>Most household items</li>
                  <li>Electronics and gadgets</li>
                  <li>Clothing and accessories</li>
                  <li>Books and media</li>
                  <li>Home and garden items</li>
                </ul>
              </div>
              <div className="restriction-item">
                <h3>❌ What We Don't Ship</h3>
                <ul>
                  <li>Hazardous materials</li>
                  <li>Perishable items</li>
                  <li>Live animals</li>
                  <li>Illegal items</li>
                  <li>Oversized items (over 50 lbs)</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="shipping-section">
            <h2>International Shipping</h2>
            <div className="international-info">
              <div className="international-card">
                <h3>Available Countries</h3>
                <p>We ship to most countries worldwide. Check our shipping calculator for specific rates and delivery times for your location.</p>
              </div>
              <div className="international-card">
                <h3>Customs & Duties</h3>
                <p>International orders may be subject to customs duties and taxes. These are the responsibility of the recipient and are not included in our shipping costs.</p>
              </div>
            </div>
          </div>

          <div className="shipping-section">
            <h2>Need Help?</h2>
            <p>Have questions about shipping? Our customer service team is here to help!</p>
            <div className="contact-options">
              <div className="contact-option">
                <div className="option-icon">📧</div>
                <h3>Email Support</h3>
                <p>shipping@inifiy.com</p>
                <span>Response within 24 hours</span>
              </div>
              <div className="contact-option">
                <div className="option-icon">📞</div>
                <h3>Phone Support</h3>
                <p>+1 (555) 123-4567</p>
                <span>Mon-Fri, 9AM-6PM EST</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingInfo; 